import { useContext } from 'react'
import { HospitalContext } from '../context/HospitalContext'

export const useHospitalSelection = () => {
    const context = useContext(HospitalContext)
    if (!context) {
        throw new Error('useHospitalSelection must be used within HospitalProvider')
    }
    return context
}
